import { trpc } from "@blis/trpc/react";

export type IntegrationKindKey = "ITRANSPLANT";

/**
 * React hook that returns whether `kind` is enabled for `orgId`.
 *
 * Use this to gate UI affordances — e.g. only show the iTransplant indicator
 * on an accession detail page when the integration is enabled for the
 * accession's creating org.
 *
 * Returns `enabled: false` while loading so callers can render the absence by
 * default and reveal the integration only after we've confirmed it's on.
 */
export function useIntegration(
  kind: IntegrationKindKey,
  orgId: number | null | undefined,
) {
  const query = trpc.integrations.isEnabled.useQuery(
    { kind, orgId: orgId ?? 0 },
    { enabled: typeof orgId === "number" && orgId > 0 },
  );

  return {
    enabled: !!query.data?.enabled,
    isLoading: query.isLoading,
  };
}
